export default __webpack_public_path__ + "static/media/loadingmobile1.59538613.gif";